import Vue from 'vue'
import Vuex from 'vuex'

Vue.use(Vuex)

const defaultLoginResult = {
  token: null,
  userId: null,
  userName: null,
  userLevelCode: null
}

function clearCookie(name) {
  document.cookie = `${name}=; path=/; max-age=0`;
}

export default new Vuex.Store({
  state: {
    isLogin: false,
    loginResult: defaultLoginResult,
  },
  mutations: {
    init(state){
      let loginResult = JSON.parse(localStorage.getItem("loginResult"));
      console.log(localStorage.getItem("loginResult"));
      if (loginResult !=null){
        state.loginResult = loginResult;
      }
    },
    login(state, loginResult){
      state.loginResult = loginResult;
    },
    logout(state){
      localStorage.removeItem("loginResult");
      clearCookie('server-token');
      clearCookie('userId');
      state.loginResult = { ...defaultLoginResult };
    },
    updateIcon(state, icon){
      state.loginResult.icon = icon;
      localStorage.setItem("loginResult", JSON.stringify(state.loginResult));
    }
  },
  actions: {
  },
  getters: {
    isLogin:state=>state.loginResult.userId !== null,
    userID:state=>state.loginResult.userId,
    username:state=>state.loginResult.userName,
    accessToken:state=>state.loginResult.token,
    userLevelCode:state=>state.loginResult.userLevelCode,
    isAdmin:state=>state.loginResult.userLevelCode && state.loginResult.userLevelCode >= 20,
  }
})
